/**
 * Created by neo on 19.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { Ingredient, createIngredient } from '../Ingredient/Ingredient';
import { Measure, createMeasure } from '../Measure';

export type RecipeIngredient = Ingredient & {
  measures: Measure;
  getMeasurement(metric?: boolean): string;
};

export function createRecipeIngredient(json?: Partial<RecipeIngredient>): RecipeIngredient {
  const base = createIngredient(json);
  return makeAutoObservable({
    ...base,
    measures: createMeasure(json?.measures),

    getMeasurement(metric: boolean = true): string {
      return metric
        ? `${this.measures.metric.amount} ${this.measures.metric.unitShort}`
        : `${this.measures.us.amount} ${this.measures.us.unitShort}`;
    },
  });
}
